import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 1.4rem;
  cursor: pointer;
  width: max-content;

  input[type='checkbox'] {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;

    &:checked ~ span {
      background-color: var(--primary_color);
    }

    &:not(:checked) ~ span {
      border-color: var(--primary_color);
    }

    &:checked ~ span:after {
      display: block;
    }
  }

  span {
    position: absolute;
    left: 0;
    height: 0.9rem;
    width: 0.9rem;
    border-radius: 0.2rem;
    background-color: var(--white);
    border: 0.1rem solid var(--primary_color);
    z-index: 1;

    &::after {
      content: '';
      position: absolute;
      display: none;
      left: 0.25rem;
      top: 0.1rem;
      width: 0.2rem;
      height: 0.3rem;
      border: solid var(--white);
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }

  p {
    color: var(--black);
  }

  @media (max-width: 400px) {
    .input-checkbox input[type='checkbox']:checked ~ span:after {
      top: 0;
      left: 0.15rem;
    }
  }
`;
